import { Avatar } from "antd";
import React from "react";
import styled from "styled-components";

export const Logo = ({ size, src }) => (
	<StyledLogo size={size} shape="square" src={src}></StyledLogo>
);

const StyledLogo = styled(Avatar)`
	background-color: #fff; // for folder component only (for contrast with blue bg)

	img {
		object-fit: contain;
	}
`;
